module.exports = __webpack_public_path__ + "static/html_4-d8a4e7f35cf5b554f131279d896ca14a.jpg";